"use client"

import { DiscordSDK } from "@discord/embedded-app-sdk"
import {ReactNode, createContext, useContext} from "react";
import {useQuery} from "@tanstack/react-query";

const DiscordContext = createContext<{ sdk: DiscordSDK } | null>(null);

let sdk: DiscordSDK | undefined

export function DiscordActivityProvider({ children, enabled }: { children: ReactNode, enabled?: boolean }) {
    const sdkResult = useQuery({
        queryKey: ["discord-sdk"],
        retry: false,
        enabled: enabled ?? true,
        queryFn: async () => {
            if (!sdk) sdk = new DiscordSDK(process.env.NEXT_PUBLIC_DISCORD_CLIENT_ID ?? "")
            await sdk.ready()
            return sdk
        }
    })

    // const authResult = useQuery({
    //     queryKey: ["discord-auth", sdkResult],
    //     enabled: sdkResult.status === "success",
    //     queryFn: async () => {
    //         if (!sdkResult.data) return
    //         sdkResult.data.
    //         sdkResult.data.commands.authenticate()
    //     }
    // })

    return <DiscordContext value={sdkResult.data ? {sdk: sdkResult.data} : null}>
        {children}
    </DiscordContext>
}

export function useDiscord(guarnteed?: false): { sdk: DiscordSDK } | null
export function useDiscord(guarnteed: true): { sdk: DiscordSDK }
export function useDiscord(guarnteed = true) {
    const context = useContext(DiscordContext)
    if (!context && guarnteed) throw new Error("Discord SDK not initialized")
    return context
}
